import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../Actions/AxiosInstance";
import { DateConversion } from "../../../../Utils/dates";
import addressEmployee from "../../../../Assets/Images/dependents.svg";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import FloatingActionButtons from "../../../../Component/FloatingActionButton/FloatingActionButtons";
import createstore from "../../../../store";
import EmpImportantDateForm from "./EmpDependentForm";
import If from "../../../../Component/Common/If";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";
import { getFormattedDate } from "../../../../Utils";

class EmpDependent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 2,
      allDependentsDetails: [],
      successFlag: false,
      hideButton: false,
      dataReceived: false,
      masterprofileid:null,
    };
  }

  componentDidMount() {
    // CustomForm();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");

    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
        masterprofileid
      },
      () => {
        this.GetAllDependentsDetails();
      },
    );
  }

  SetFlag(value, success, e) {
    const flag = value;
    const successFlag = success;
    this.setState({ flag, DependentDetails: {}, successFlag }, () => {
      if (value != 1) this.GetAllDependentsDetails();
      this.props.UpdateStrength(true);
    });
  }

  GetAllDependentsDetails() {
    const URL = "employee/getempalldependent";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            allDependentsDetails: result.data.result,
            flag: 2,
            dataReceived: true,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularDependentDetails(value, data, e) {
    const DependentDetails = data;
    const flag = value;
    this.setState({ DependentDetails, flag });
  }

  DeleteEmpDependents = (item) => {
    const employeeid = this.props.colleagueid || this.state.employeeid;
    const data = {
      employeeid : employeeid,
    }
    const URL = `employee/deleteempdependent/${item.employeedependentid}`;
    instance
      .delete(URL,this.state.masterprofileid && this.state.masterprofileid == 9 && {data})
      .then((resp) => {
        this.GetAllDependentsDetails();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpDependents(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small">
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    let model;
    const { ShortDateFormat, dataReceived, hideButton } = this.state;
    const { flag } = this.state;
    const { classes } = this.props;
    if (flag === 0) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {!hideButton ? (
                <CreateComp
                  text="A little about the people you love"
                  heading={
                    <FormattedMessage
                      id="LbFamilyDependents"
                      defaultMessage="Family Dependents!"
                    />
                  }
                  onCreate={this.SetFlag.bind(this, 1, false)}
                  imageSrc={addressEmployee}
                />
              ) : (
                <NoRecordFound />
              )}
            </Grid>
          </Grid>
        </div>
      );
    }

    if (flag === 1) {
      model = (
        <div>
          <EmpImportantDateForm
            SetFlag={this.SetFlag.bind(this)}
            data={this.state.DependentDetails}
            colleagueid={this.state.colleagueid}
          />
        </div>
      );
    }

    if (flag === 2) {
      model = (
        <div className="profile-data-view-page">
          {this.state.successFlag ? (
            <p className="input-form-label address-label">
              {" "}
              <FormattedMessage
                id="LbSuccessfullyAdded"
                defaultMessage="Congratulations, you have added your dependent details successfully."
              />{" "}
            </p>
          ) : (
            ""
          )}
          {this.state.allDependentsDetails.length > 0 ? (
            <div className="width100">
              <div>
                {this.state.allDependentsDetails.map((data) => (
                  <div className="padding-bottom-20 position-rel">
                    <span className="address-data display-block">
                      {data.firstname} {data.lastname}
                    </span>
                    <span className="address-data margin-right-16 inline-display">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="floatleft"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                      </svg>
                      <span className="floatleft margin-left-8">
                        {data.contactnumber}
                      </span>
                    </span>
                    {data.dob ? (
                      <span className="address-data inline-display">
                        <svg
                          width="20px"
                          height="20px"
                          viewBox="0 0 18 22"
                          version="1.1"
                          className="floatleft"
                        >
                          <g
                            id="type-form"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              id="4.5_imp.dates"
                              transform="translate(-296.000000, -168.000000)"
                            >
                              <g
                                id="baseline-cake-24px"
                                transform="translate(293.000000, 168.000000)"
                              >
                                <polygon
                                  id="Path"
                                  points="0 0 24 0 24 24 0 24"
                                />
                                <path
                                  d="M12,6 C13.11,6 14,5.1 14,4 C14,3.62 13.9,3.27 13.71,2.97 L12,0 L10.29,2.97 C10.1,3.27 10,3.62 10,4 C10,5.1 10.9,6 12,6 Z M16.6,15.99 L15.53,14.92 L14.45,15.99 C13.15,17.29 10.87,17.3 9.56,15.99 L8.49,14.92 L7.4,15.99 C6.75,16.64 5.88,17 4.96,17 C4.23,17 3.56,16.77 3,16.39 L3,21 C3,21.55 3.45,22 4,22 L20,22 C20.55,22 21,21.55 21,21 L21,16.39 C20.44,16.77 19.77,17 19.04,17 C18.12,17 17.25,16.64 16.6,15.99 Z M18,9 L13,9 L13,7 L11,7 L11,9 L6,9 C4.34,9 3,10.34 3,12 L3,13.54 C3,14.62 3.88,15.5 4.96,15.5 C5.48,15.5 5.98,15.3 6.34,14.93 L8.48,12.8 L10.61,14.93 C11.35,15.67 12.64,15.67 13.38,14.93 L15.52,12.8 L17.65,14.93 C18.02,15.3 18.51,15.5 19.03,15.5 C20.11,15.5 20.99,14.62 20.99,13.54 L20.99,12 C21,10.34 19.66,9 18,9 Z"
                                  id="Shape"
                                  fill="#111111"
                                  fillRule="nonzero"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span className="floatleft margin-left-8">
                          {getFormattedDate(data.dob, ShortDateFormat)}
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                    <br />
                    <span className="display-block">
                      <Chip
                        label={data.relationship}
                        className={classes.chip}
                      />
                    </span>

                    <If condition={!hideButton}>
                      <div>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={this.GetPerticularDependentDetails.bind(
                            this,
                            1,
                            data,
                          )}
                          width="24"
                          style={{ marginRight: 40 }}
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                        </svg>
                        <svg
                          className={"address-edit cursour-pointer"}
                          onClick={() => this.Deleteconfirmation(data)}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                          <path fill="none" d="M0 0h24v24H0V0z" />
                        </svg>
                      </div>
                    </If>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <FormattedMessage
                id="LbNoRecordFound"
                defaultMessage="No Record Found"
              />
            </div>
          )}
          {!hideButton && (
            <div
              className={"add-more-button"}
              onClick={this.SetFlag.bind(this, 1, false)}
            >
              <Button variant="contained" color="primary" className="no-shadow">
                Add More
              </Button>
            </div>
          )}
        </div>
      );
    }

    return (
      <If condition={dataReceived}>
        <div>{model}</div>
      </If>
    );
  }
}
EmpDependent.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withSnackbar(EmpDependent);
